"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const enum_1 = require("./const/enum");
const market_conventions_1 = require("./const/market-conventions");
exports.invertSide = (side) => side === enum_1.SIDE.BUY ? enum_1.SIDE.SELL : enum_1.SIDE.BUY;
const qtyValid = (str) => {
    if (str === "" || str === undefined) {
        return true;
    }
    const num = Number(str);
    if (isNaN(num)) {
        return false;
    }
    return Number.isFinite(num);
};
class BuySellHelperImmutable {
    /**
     * Immutable BuySellHelper ro assist in constructing the
     * @param {string|object} ccy1  [Optional]  Uppercase currency OR Internal data object
     * @param {string}        ccy2  [Optional]  Uppercase currency
     * @param {string}        ccy   [Optional]  Uppercase currency
     */
    constructor(data) {
        this.data = data;
    }
    // Set variables
    setBuyCcy(buyCcy) {
        return this._updateInternal({ buyCcy });
    }
    setSellCcy(sellCcy) {
        return this._updateInternal({ sellCcy });
    }
    setCcy(side, ccy) {
        switch (side) {
            case enum_1.SIDE.BUY:
                return this.setBuyCcy(ccy);
            case enum_1.SIDE.SELL:
                return this.setSellCcy(ccy);
        }
    }
    swapCcy() {
        return this._updateInternal({
            buyCcy: this.data.sellCcy,
            sellCcy: this.data.buyCcy,
            fixSide: exports.invertSide(this.data.fixSide),
        });
    }
    fixBuyQty(quantity) {
        return this._updateInternal({ fixSide: enum_1.SIDE.BUY, quantity });
    }
    fixSellQty(quantity) {
        return this._updateInternal({ fixSide: enum_1.SIDE.SELL, quantity });
    }
    fixQty(side, quantity) {
        switch (side) {
            case enum_1.SIDE.BUY:
                return this.fixBuyQty(quantity);
            case enum_1.SIDE.SELL:
                return this.fixSellQty(quantity);
        }
    }
    // Retrieve options
    symbol() {
        const buyIndex = market_conventions_1.CONVENTIONAL_BASE.indexOf(this.data.buyCcy);
        const sellIndex = market_conventions_1.CONVENTIONAL_BASE.indexOf(this.data.sellCcy);
        if (sellIndex === undefined || sellIndex === -1) {
            return `${this.data.buyCcy}/${this.data.sellCcy}`;
        }
        if (buyIndex === undefined || buyIndex === -1) {
            return `${this.data.sellCcy}/${this.data.buyCcy}`;
        }
        if (buyIndex < sellIndex) {
            // buy has a higher priority in the conventional base list
            return `${this.data.buyCcy}/${this.data.sellCcy}`;
        }
        return `${this.data.sellCcy}/${this.data.buyCcy}`;
    }
    currency() {
        return this.data.fixSide === enum_1.SIDE.BUY
            ? this.data.buyCcy
            : this.data.sellCcy;
    }
    side() {
        return this.data.fixSide;
    }
    rateField() {
        return "client_bid";
    }
    quantity() {
        return this.data.quantity;
    }
    buySideFixed() {
        return this.data.fixSide === enum_1.SIDE.BUY;
    }
    sellSideFixed() {
        return this.data.fixSide === enum_1.SIDE.SELL;
    }
    fixed(side) {
        return this.data.fixSide === side;
    }
    fixSide() {
        return this.data.fixSide;
    }
    buyQuantityValid() {
        return qtyValid(this.buyQty());
    }
    sellQuantityValid() {
        return qtyValid(this.sellQty());
    }
    quantityValid(side) {
        switch (side) {
            case enum_1.SIDE.BUY:
                return this.buyQuantityValid();
            case enum_1.SIDE.SELL:
                return this.sellQuantityValid();
        }
    }
    buyQty() {
        return this.buySideFixed() ? this.data.quantity : undefined;
    }
    sellQty() {
        return this.sellSideFixed() ? this.data.quantity : undefined;
    }
    qty(side) {
        switch (side) {
            case enum_1.SIDE.BUY:
                return this.buyQty();
            case enum_1.SIDE.SELL:
                return this.sellQty();
        }
    }
    buyCcy() {
        return this.data.buyCcy;
    }
    sellCcy() {
        return this.data.sellCcy;
    }
    ccy(side) {
        switch (side) {
            case enum_1.SIDE.BUY:
                return this.buyCcy();
            case enum_1.SIDE.SELL:
                return this.sellCcy();
        }
    }
    // Private Functions
    _updateInternal(data) {
        return new BuySellHelperImmutable(Object.assign(this.data, data));
    }
}
exports.BuySellHelperImmutable = BuySellHelperImmutable;
exports.default = BuySellHelperImmutable;
